export const getOnboardSteps = (
  t: (text: string) => string,
  itemId: string | number,
  onBoardStart: boolean,
) => {
  if (!onBoardStart) return [];
  return [
    {
      disableBeacon: true,
      target: '#tourStep-1',
      content: t(
        'Welcome to the Waites Full Service Dashboard. Using machine learning, our worldwide team of analysts are monitoring your equipment 24/7.',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-2',
      content: t('Upon logging in, the Action Items page is displayed by default.'),
      placement: 'bottom',
    },
    {
      target: '#tourStep-3',
      content: t(
        'By default, the action items for all facilities you have access to are displayed. You can select a specific facility or subsection if desired.',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-4',
      content: t(
        'Click “Show map” to view the facility list in a map layout, and to collapse the map, click the Hide map link. If you click a location on the map or in the Global Map section, the Facility drop-down list will be updated (and hence all data in the dashboard as well).',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-5',
      content: t('Year-to-Date (YTD) company metrics are displayed to track your successes.'),
      placement: 'bottom',
    },
    {
      target: '#tourStep-6',
      content: t('Click "View more statistics" to view additional savings details.'),
      placement: 'bottom',
    },
    {
      target: '#tourStep-7',
      content: t(
        'The action item list is broken into two sections. The “Needs Response” section includes action items that need a response from on-site personnel.',
      ),
      placement: 'top',
    },
    {
      target: '#tourStep-8',
      content: t(
        'The "Pending Update" section includes action items that currently do not require a response from on-site personnel. This can include action items that are snoozed, on hold, or awaiting a response from Waites.',
      ),
      placement: 'top',
    },
    {
      target: '#tourStep-9',
      content: t('You can filter action items by Urgency, Action Item Type, and Status.'),
      placement: 'top',
    },
    {
      target: '#tourStep-10',
      content: t(
        'A summary of the open action items is displayed above the list of action items, which includes the total number of action items and the number of critical, high, and standard urgency action items.',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-11',
      content: t(
        'If you would like a Waites analyst to investigate an equipment issue that does not currently have an open action item, you can add one by clicking "Add Action Item".',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-12',
      content: t(
        'Click anywhere in the row to view the Action Item details. Note: action items you have not opened yet are highlighted in bold. Once you view an action item, it will no longer be bold.',
      ),
      placement: 'top',
    },
    {
      target: 'redirect-1',
      data: {
        itemId: itemId,
        navigateAfter: itemId ? `ai/${itemId}` : 'sensors',
      },
    },
  ];
};
